import { useQuery } from 'react-apollo';
import { portfolioById } from '../queries';

export function usePortfolioById(id) {
  const { data, refetch: refresh, loading: isLoading } = useQuery(
    portfolioById,
    {
      fetchPolicy: 'cache-first',
      skip: !id,
      variables: { id },
    },
  );
  const portfolio = data?.allPortfolios?.edges?.[0]?.node;
  if (portfolio && portfolio.years) {
    try {
      const allInvestments = portfolio.investments?.edges ?? [];
      const allocations = allInvestments.reduce((total, inv) => {
        total += inv?.node?.allocations?.edges.length;
        return total;
      }, 0);
      portfolio.years = typeof portfolio.years === 'string' ? JSON.parse(portfolio.years) : portfolio.years;
      portfolio.investments = allInvestments.length;
      portfolio.allocations = allocations;
    } catch (er) {
      console.warn(er);
    }
  }
  return { portfolio, refresh, isLoading };
}
